import { CByteArray } from "./CByteArray";

export class CTPGHState {
    private m_mcL:fgui.GMovieClip;

    constructor() {
        this.m_mcL = null;
    }

    public attachMC(mc:fgui.GMovieClip):void {
        this.m_mcL = mc;
    }

    public Hide():void {
        this.m_mcL.visible = false;
    }

    public Show(what:number, pCallback:CByteArray = null, v:number = 1):void {
        var dm:number = 1250;
        if ( what == 0 ) {
            //CSoundRes.Instance.PlayGameSound(24);
        }
        else if ( what == 4 || what == 5 ) {
            dm = 2500;
            //CSoundRes.Instance.PlayGameSound(25);
        }
        this.m_mcL.frame = what;
        this.m_mcL.scaleX = 2.0;
        this.m_mcL.scaleY = 2.0;
        this.m_mcL.visible = true;
        var that = this;
        createjs.Tween.get(this.m_mcL)
                .to({scaleX:1.0, scaleY:1.0}, 250, createjs.Ease.quadIn)
                .call(function(){
                    if(pCallback) pCallback.SetInt(0, v);
                })
                .wait(dm)
                .to({scaleX:0.1, scaleY:0.1}, 250, createjs.Ease.quadOut)
                .call(function(){
                    that.m_mcL.visible = false;
                })
    }
}